import { Box, ClickAwayListener, Menu, useTheme } from '@mui/material';
import { Dispatch, FC, ReactNode, SetStateAction } from 'react';
import { CornerMenuSvg } from './CornerMenuSvg';

interface Props {
  children: ReactNode;
  onClose: () => void;
  open: boolean;
  anchorEl: HTMLElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
}

const MiniNavbarMenu: FC<Props> = ({ children, setAnchorEl, anchorEl, onClose, open }) => {
  return (
    <ClickAwayListener
      onClickAway={(event) => {
        if (anchorEl && !anchorEl.contains(event.target as Node)) {
          onClose();
        }
      }}
    >
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        onClick={() => setAnchorEl(null)}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        slotProps={{
          paper: {
            sx: {
              overflow: 'visible',
              border: '.6px solid',
              boxShadow: 'none !important',
              marginLeft: -19,
              marginTop: 1.3,
              p: 2,
              borderColor: ({ palette }) => palette.text.secondary,
              borderRadius: 2,
              borderTopLeftRadius: 0,
              '& ul': {
                paddingTop: 0,
                paddingBottom: 0,
              },
            },
          },
        }}
        sx={{ marginLeft: '90px' }}
        hideBackdrop
      >
        <Box
          sx={{
            position: 'absolute',
            pointerEvents: 'none',
            top: -10.5,
            left: -24.5,
            height: 70,
          }}
        >
          <CornerMenuSvg />
        </Box>
        {children}
      </Menu>
    </ClickAwayListener>
  );
};
export default MiniNavbarMenu;
